import { useState } from 'react';
import { motion } from 'framer-motion';
import ShareSheet from './ShareSheet';

export default function FloatingButtons() {
  const [shareOpen, setShareOpen] = useState(false);

  return (
    <>
      {/* Share Button */}
      <motion.button
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 3.4, duration: 0.5 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setShareOpen(true)}
        className="fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-copper shadow-[0_8px_24px_rgba(198,142,95,0.25)] flex items-center justify-center text-white transition-colors hover:bg-copper-dark"
        aria-label="Share invitation"
      >
        <i className="ri-share-line text-lg w-5 h-5 flex items-center justify-center" />
      </motion.button>

      <ShareSheet isOpen={shareOpen} onClose={() => setShareOpen(false)} />
    </>
  );
}